// Аварийный выключатель: false полностью возвращает стандартный ScrollToTop.
export const ORDER_LOOKUP_RETURN_ENABLED = true;

const STORAGE_KEY = 'order_lookup_return_context_v1';
const MAX_CONTEXT_AGE_MS = 15 * 60 * 1000;

const getRouteSignature = (location) => (
  `${location?.pathname || '/'}${location?.search || ''}${location?.hash || ''}`
);

const getRouteScrollContainer = () => {
  if (typeof document === 'undefined') return null;
  return document.querySelector('[data-route-scroll-container="true"]')
    || document.querySelector('.main-scrollable')
    || document.scrollingElement
    || document.documentElement
    || document.body;
};

const clearStoredContext = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    void error;
  }
};

export const saveOrderLookupReturnContext = (location) => {
  if (!ORDER_LOOKUP_RETURN_ENABLED || typeof window === 'undefined') return;

  const scrollContainer = getRouteScrollContainer();
  const scrollTop = Number(scrollContainer?.scrollTop ?? window.scrollY ?? 0);

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
      route: getRouteSignature(location),
      scrollTop: Number.isFinite(scrollTop) ? Math.max(0, scrollTop) : 0,
      createdAt: Date.now(),
    }));
  } catch (error) {
    void error;
  }
};

export const consumeOrderLookupReturnContext = (location, navigationType) => {
  if (!ORDER_LOOKUP_RETURN_ENABLED || navigationType !== 'POP') return null;

  let context = null;
  try {
    context = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
  } catch (error) {
    clearStoredContext();
    return null;
  }

  if (!context || typeof context !== 'object') return null;

  const createdAt = Number(context.createdAt || 0);
  if (!createdAt || Date.now() - createdAt > MAX_CONTEXT_AGE_MS) {
    clearStoredContext();
    return null;
  }

  if (context.route !== getRouteSignature(location)) return null;

  clearStoredContext();
  const scrollTop = Number(context.scrollTop || 0);
  return {
    scrollTop: Number.isFinite(scrollTop) ? Math.max(0, scrollTop) : 0,
  };
};
